import React from 'react';
import {
  useLocation,
  useNavigate,
  useParams
} from 'react-router-dom';

export function useRouter() {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  return React.useMemo(() => ({
    location,
    params,
    navigate,
  }), [location, params, navigate]);
}

export interface WithRouterProps {
  location: ReturnType<typeof useLocation>;
  params: Record<string, string>;
  navigate: ReturnType<typeof useNavigate>;
}

/**
 * @deprecated The `withRouter` HOC is deprecated. Please use the `useRouter` hook in functional components instead.
 */
export const withRouter = <Props extends WithRouterProps>(
  Component: React.ComponentType<Props>
) => {
  const WithRouter = (props: Omit<Props, keyof WithRouterProps>) => {
    React.useEffect(() => {
      console.warn(
        `Deprecation Warning: The HOC 'withRouter' is deprecated. Please use the 'useRouter' hook instead in '${
          Component.displayName || Component.name || "Component"
        }'.`
      );
    }, []);

    const { location, params, navigate } = useRouter();

    return (
      <Component
        {...(props as Props)}
        location={location}
        params={params}
        navigate={navigate}
      />
    );
  };

  WithRouter.displayName = `withRouter(${Component.displayName || Component.name || "Component"})`;

  return WithRouter;
};
